/**
 * Per-destination gallery of 6 curated Unsplash photos.
 * Slot layout (matches CSS mosaic):
 *   0 → wide landscape  (900×520)  — row 1 left (spans 2 cols)
 *   1 → portrait/square (500×520)  — row 1 right
 *   2 → activity shot   (500×400)  — row 2 left
 *   3 → detail / food   (500×400)  — row 2 center
 *   4 → neighborhood    (500×400)  — row 2 right
 *   5 → panoramic       (1200×480) — row 3 full-width
 */
const DESTINATION_GALLERIES = {

    /* ── BEACH ───────────────────────────────────────────── */
    'maldives-beach': [
        'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576158831003-d41033ec31fd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583623025817-d180a2221d0a?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516815231560-8f41ec531527?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1620065487644-1080510335f5?w=1200&h=480&fit=crop&q=80',
    ],
    'bali-beach': [
        'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1604999333679-b86d54738315?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1573790387438-4da905039392?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=1200&h=480&fit=crop&q=80',
    ],
    'santorini-beach': [
        'https://images.unsplash.com/photo-1580502304784-8985b7eb7260?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1563789031959-4c02bcb41319?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1696519669474-3001c0e2b548?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1604145195376-e2c8195adf29?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1530841377377-3ff06c0ca713?w=1200&h=480&fit=crop&q=80',
    ],
    'tulum-beach': [
        'https://images.unsplash.com/photo-1645557180229-98bfc29dbdbf?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1581710862235-eb6e05d8783f?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1666051637734-de3231713ed9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1617220361167-9d556b850824?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1597351183340-ebd88b18ed6b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1665618980645-ca9cd5e68508?w=1200&h=480&fit=crop&q=80',
    ],
    'amalfi-coast-beach': [
        'https://images.unsplash.com/photo-1612698093158-e07ac200d44e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1530476219733-88085e45aa2c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1595971785000-610dc20aa6a3?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1597324774222-232f8fec951b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1579285014902-da8d2ba6007b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583844056361-4418a8f2a985?w=1200&h=480&fit=crop&q=80',
    ],
    'phuket-beach': [
        'https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1551418843-01c6b62e864d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1596879857570-7b6b9018bcb6?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1704314315344-cd10b9779ce6?w=1200&h=480&fit=crop&q=80',
    ],
    'cancun-beach': [
        'https://images.unsplash.com/photo-1552074284-5e88ef1aef18?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1630252421399-ddde79af47b3?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1602088113235-229c19758e9f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1743697706311-120044ecaf22?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570737543098-0983d88f796d?w=1200&h=480&fit=crop&q=80',
    ],
    'zanzibar-beach': [
        'https://images.unsplash.com/photo-1586861635167-e5223aadc9fe?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1575999502951-4ab25b5ca889?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1646668072507-b2215b873c70?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1549035092-33b2937b075a?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1607444807093-eefb769187da?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1620896712848-d05411ec91ec?w=1200&h=480&fit=crop&q=80',
    ],
    'hawaii-beach': [
        'https://images.unsplash.com/photo-1507876466758-bc54f384809c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483168527879-c66136b56105?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1471079502516-250c19af6928?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1545251142-f32339076e6d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=1200&h=480&fit=crop&q=80',
    ],
    'mykonos-beach': [
        'https://images.unsplash.com/photo-1695441396429-0c53cf57c29b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1657141462746-13f0468d5e65?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1653051145435-b13b5563a134?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1600541205150-fd0ddc331edf?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1705090708508-f67736103728?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1761755889798-94e68abb7baa?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── CULTURE ─────────────────────────────────────────── */
    'kyoto-culture': [
        'https://images.unsplash.com/photo-1578469645742-46cae010e5d4?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1503640538573-148065ba4904?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1524413840807-0c3cb6fa808d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1562632725-c1731570f5da?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1717649389730-ba6d16053b43?w=1200&h=480&fit=crop&q=80',
    ],
    'rome-culture': [
        'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1529154036614-a60975f5c760?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1529260830199-42c24126f198?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548585742-1df49e753a83?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=1200&h=480&fit=crop&q=80',
    ],
    'athens-culture': [
        'https://images.unsplash.com/photo-1661501760606-88ee3a22d645?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1603565816030-6b389eeb23cb?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583656696771-2afded31a36c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599423217192-34da246be9e8?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1580940470227-739a2f0ab9f7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1678786393784-45cdc1663300?w=1200&h=480&fit=crop&q=80',
    ],
    'istanbul-culture': [
        'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1527838832700-5059252407fa?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1636537511494-c3e558e0702b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?w=1200&h=480&fit=crop&q=80',
    ],
    'marrakech-culture': [
        'https://images.unsplash.com/photo-1597212618440-806262de4f6b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1553913861-c0fddf2619ee?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1772580310425-63f2290c2ba7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1589008591357-0f2873177002?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1702211374779-792e3df71b59?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1489493887464-892be6d1daae?w=1200&h=480&fit=crop&q=80',
    ],
    'prague-culture': [
        'https://images.unsplash.com/photo-1564511287568-54483b52a35e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1600623471616-8c1966c91ff6?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1589312893179-38d2eb60655d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1629044562928-6946d8d3feea?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1473951574080-01fe45ec8643?w=1200&h=480&fit=crop&q=80',
    ],
    'vienna-culture': [
        'https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1573599852326-2d4da0bbe613?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1569230919100-d3fd5e1132f4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1609856878074-cf31e21ccb6b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519923041107-e4dc8d9193da?w=1200&h=480&fit=crop&q=80',
    ],
    'havana-culture': [
        'https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1508532566027-b2032cd8a715?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583586507353-61a65fa3d56d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1518754744014-dcca006cd68f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1570299437488-d430e1e677c7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1536686598161-1b946fd6dfcf?w=1200&h=480&fit=crop&q=80',
    ],
    'florence-culture': [
        'https://images.unsplash.com/photo-1541370976299-4d24ebbc9077?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1601195576601-346d58e024c0?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1621775757002-02f63aaf51c1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1564801629778-eabf6ed7d440?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1606230762486-988508c970dd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1472507393786-716cd8288c07?w=1200&h=480&fit=crop&q=80',
    ],
    'lisbon-culture': [
        'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599069158346-684fee0e414a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558102400-72da9fdbecae?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1578859651203-c7126a106b59?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1509233725247-49e657c54213?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548707309-dcebeab9ea9b?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── ADVENTURE ───────────────────────────────────────── */
    'iceland-adventure': [
        'https://images.unsplash.com/photo-1500043357865-c6b8827edf10?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1529963183134-61a90db47eaf?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1476610182048-b716b8518aae?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1595687453172-253f44ed3975?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1498008122250-bcb854c8462d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519092437326-bfd121eb53ae?w=1200&h=480&fit=crop&q=80',
    ],
    'new-zealand-adventure': [
        'https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1494500764479-0c8f2919a3d8?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1597655601841-214a4cfe8b2c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528184039930-bd03972bd974?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1547314283-befb6cc5cf29?w=1200&h=480&fit=crop&q=80',
    ],
    'patagonia-adventure': [
        'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558517286-8a9cb0b8c793?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558517286-6b7b81953cb5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1682024619121-aabb0305a496?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1708394534994-4e66c2b09e1f?w=1200&h=480&fit=crop&q=80',
    ],
    'nepal-adventure': [
        'https://images.unsplash.com/photo-1580424917967-a8867a6e676e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1553886334-43d24f24d3bd?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1511215579272-6192432f83bc?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1572109801525-0bb0272e8579?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1636513988093-126e51dee32d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1718179634911-8551f8b0cccf?w=1200&h=480&fit=crop&q=80',
    ],
    'costa-rica-adventure': [
        'https://images.unsplash.com/photo-1518259102261-b40117eabbc9?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520520731457-9283dd14aa66?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592593210599-492c25d93ef9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1628212093754-39237668d1cd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1455156218388-5e61b526818b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1614931454423-4b4bac270e8d?w=1200&h=480&fit=crop&q=80',
    ],
    'norwegian-fjords-adventure': [
        'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1663428520845-056989f8a664?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1664825381616-5cb8397fd9b1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1544009520-e2ea9189f15e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1504233529578-6d46baba6d34?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1508592931388-95bc7b61033d?w=1200&h=480&fit=crop&q=80',
    ],
    'borneo-adventure': [
        'https://images.unsplash.com/photo-1701289870791-594cf2ce0448?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1762482614898-9e826d224a2e?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1654180639088-65f1bc3312d6?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1654180623810-fe0d6b5dd4cc?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1791467721567-020f9e5ea57c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1654180635272-13fc4be2ecf3?w=1200&h=480&fit=crop&q=80',
    ],
    'swiss-alps-adventure': [
        'https://images.unsplash.com/photo-1729010733988-637a20cc5e37?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1566475955255-404134a79aeb?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1693647667711-89c401166b07?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1667682343189-35937293fb66?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1607585011081-241d2bacb7de?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1692842561035-a30beef0ac23?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── FOOD ────────────────────────────────────────────── */
    'bangkok-food': [
        'https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1563492065599-3520f775eeed?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528181304800-259b08848526?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1547640084-1dfcc7ef3b22?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1510379872535-9310dc6fd6a7?w=1200&h=480&fit=crop&q=80',
    ],
    'tokyo-food': [
        'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1573455494060-c5595004fb6c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1549693578-d683be217e58?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1480796927426-f609979314bd?w=1200&h=480&fit=crop&q=80',
    ],
    'barcelona-food': [
        'https://images.unsplash.com/photo-1593368858664-a7fe556ab936?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1564221710304-0b37c8b9d729?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1534001265532-393289eb8ed3?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1752605158021-6ca2665f6acc?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1567437890326-0084ea9d99e9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1464790719320-516ecd75af6c?w=1200&h=480&fit=crop&q=80',
    ],
    'bologna-food': [
        'https://images.unsplash.com/photo-1682277303978-7ba42c704590?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1592151144537-5635115dbd3c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1646129073241-b37f7229b74e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1775343968253-14b55847c641?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1673043071399-c7069ee31910?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1683736071800-ad7ed27dc057?w=1200&h=480&fit=crop&q=80',
    ],
    'mexico-city-food': [
        'https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1547686669-9a8cb1a22d91?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1580934738416-ad531f2920f7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1521216774850-01bc1c5fe0da?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1601585144584-2a53183be14c?w=1200&h=480&fit=crop&q=80',
    ],
    'naples-food': [
        'https://images.unsplash.com/photo-1593488524895-8f05d3e09181?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1673598509238-6faece3a941c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599682715474-361182378581?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1587085416963-22efba033dd5?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1693849908818-9d002fe35512?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1610641819167-e9f4f393a7fe?w=1200&h=480&fit=crop&q=80',
    ],
    'copenhagen-food': [
        'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1583353342061-d43e3a8ee05a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1513622118278-bc041b3c13ed?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548186879-9a93eed687ef?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1551651767-d5ffbdd04b83?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1577346895253-445f05a6670d?w=1200&h=480&fit=crop&q=80',
    ],
    'lyon-food': [
        'https://images.unsplash.com/photo-1537015125382-74e1f1c99ac4?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1677389931416-9832636048ff?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1569087306794-db9947393580?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1724015736618-f2a734103754?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1664511749676-afe0541dd8e9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1697054601740-dfa28d40c76e?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── BUDGET ──────────────────────────────────────────── */
    'tbilisi-budget': [
        'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1561731172-9d906d7b13bf?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1505294399615-2479253a4990?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1597395529362-361ba4b8ec24?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1584097774515-8657972fdd29?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1559787248-5beaa0e086bc?w=1200&h=480&fit=crop&q=80',
    ],
    'budapest-budget': [
        'https://images.unsplash.com/photo-1616432902940-b7a1acbc60b3?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1549877452-9c387954fbc2?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1629182585837-96b0f31301b9?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1670046877696-22ffc31239dc?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1618148238267-fc3340c1a1ab?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1576431222164-bb15dd111a9f?w=1200&h=480&fit=crop&q=80',
    ],
    'bucharest-budget': [
        'https://images.unsplash.com/photo-1555217851-6141535bd771?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1730120257566-9f4b7f37f20d?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1689655451590-be38de8003e2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1654529046084-a38c42b6920f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1636196435721-e937d2ad9746?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1643786852373-d3093da7a40d?w=1200&h=480&fit=crop&q=80',
    ],
    'ho-chi-minh-city-budget': [
        'https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1536086845112-89de23aa4772?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1591269469224-0479a5f956c6?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1521019795854-14e15f600980?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1700500790259-a2527558c3f2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1580835267732-2d232d3d2655?w=1200&h=480&fit=crop&q=80',
    ],
    'sofia-budget': [
        'https://images.unsplash.com/photo-1594803294810-c860e5d29e07?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1695798598638-e8305f0ffac2?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1692344643312-03c56293b619?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1658609510512-a3f1130edcd2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1585645740103-36761f582c22?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1512757257124-b6bec9a213d1?w=1200&h=480&fit=crop&q=80',
    ],
    'krakow-budget': [
        'https://images.unsplash.com/photo-1562050380-55da3bae840c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1568749402196-dc116bcfca04?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1686252287417-6ec77009f363?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1734954912065-bbdc1b40d3c2?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1584913163718-9c8d5622c7f0?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1679254327448-de1afe354b68?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── LUXURY ──────────────────────────────────────────── */
    'dubai-luxury': [
        'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1526495124232-a04e1849168c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=1200&h=480&fit=crop&q=80',
    ],
    'monaco-luxury': [
        'https://images.unsplash.com/photo-1567165094819-ab473e9f277b?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1587851549996-57ab7c8c2b53?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1617375349209-c9efb017c86e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1692022863518-d3cae37ef135?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1610688950760-3539f765c755?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1595138320174-a64d168e9970?w=1200&h=480&fit=crop&q=80',
    ],
    'singapore-luxury': [
        'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599594026550-97d9565ceda3?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1496939376851-89342e90adcd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1600664356348-10686526af4f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1542114740389-9b46fb1e5be7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1624003974266-7cdbf877ec00?w=1200&h=480&fit=crop&q=80',
    ],
    'st-barts-luxury': [
        'https://images.unsplash.com/photo-1709738492712-43719022a3a2?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1723842161736-647233a1a8a1?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1590083948592-a5a1f0310d0e?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1759340875580-0806e4f898d8?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1551213365-54cb536fb765?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1709738492605-6ba68e28eb38?w=1200&h=480&fit=crop&q=80',
    ],
    'bora-bora-luxury': [
        'https://images.unsplash.com/photo-1706461168280-da6986cd91ec?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1738762932370-468a90e0ff68?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1652842183703-47c2f7bb8c3c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1676405328043-85738f8473ba?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1580725869538-9b164c27c44f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1706461168163-20e92384c985?w=1200&h=480&fit=crop&q=80',
    ],
    'aspen-luxury': [
        'https://images.unsplash.com/photo-1524429656589-6633a470097c?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1643089757971-2ed227b68211?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1553406488-baa24daf9b75?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1614444894791-c0c4d4286c35?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1579889551683-2e5d22deb230?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1603665184599-1baea0a37924?w=1200&h=480&fit=crop&q=80',
    ],
    'zurich-luxury': [
        'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1643981670720-eef07ebdb179?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1635922532367-401fce66aa1b?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1608479877344-9292ad9861ba?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1664459937096-d395cd77f8b8?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599082323832-2676eca28e86?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── CITY BREAKS ─────────────────────────────────────── */
    'new-york-city-break': [
        'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1568515387631-8b650bbcdb90?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1496588152823-86ff7695e68f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1522083165195-3424ed129620?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1546436836-07a91091f160?w=1200&h=480&fit=crop&q=80',
    ],
    'london-city-break': [
        'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1529655683826-aba9b3e77383?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520986606214-8b456906c813?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1486299267070-83823f5448dd?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1488747279002-c8523379faaa?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1200&h=480&fit=crop&q=80',
    ],
    'berlin-city-break': [
        'https://images.unsplash.com/photo-1587330979470-3595ac045ab0?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1599946347371-68eb71b16afc?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1618259278412-2819cbdea4dc?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1552553302-9211bf7f7053?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1554072675-66db59dba46f?w=1200&h=480&fit=crop&q=80',
    ],
    'amsterdam-city-break': [
        'https://images.unsplash.com/photo-1534180477871-5d6cc81f3920?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1584003564911-a7a321c84e1c?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1586172992865-4dfff50bd23a?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1459679749680-18eb1eb37418?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1605101100278-5d1deb2b6498?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?w=1200&h=480&fit=crop&q=80',
    ],
    'seoul-city-break': [
        'https://images.unsplash.com/photo-1532649097480-b67d52743b69?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1703825864792-5880081beaaf?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1597552661064-af143a5f3bee?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1624176193860-dd7866e5a8aa?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1448523183439-d2ac62aca997?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1554310603-d39d43033735?w=1200&h=480&fit=crop&q=80',
    ],

    /* ── ROMANCE ─────────────────────────────────────────── */
    'paris-romance': [
        'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1585944285854-d06c019aaca3?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1550340499-a6c60fc8287c?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1566127444979-b3d2b654e3d7?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=1200&h=480&fit=crop&q=80',
    ],
    'venice-romance': [
        'https://images.unsplash.com/photo-1514890547357-a9ee288728e0?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1558271736-cd043ef2e855?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1519112232436-9923c6ba3d26?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1520175480921-4edfa2983e0f?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1498307833015-e7b400441eb8?w=1200&h=480&fit=crop&q=80',
    ],
    'provence-romance': [
        'https://images.unsplash.com/photo-1600759487717-62bbb608106e?w=900&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1561718541-42d8a5e5792b?w=500&h=520&fit=crop&q=80',
        'https://images.unsplash.com/photo-1782039278158-5971a85db0b4?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1562250902-d4257599b120?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1598896169276-6391fb74ade1?w=500&h=400&fit=crop&q=80',
        'https://images.unsplash.com/photo-1673511395117-104ed47789b5?w=1200&h=480&fit=crop&q=80',
    ],
};

export default DESTINATION_GALLERIES;
